export default interface PagingSetting {
  perPage: number,
}

export const defaultPagingSetting: PagingSetting = {
  perPage: 5,
}
